// @flow

export const INIT_FORM: 'listo/orderForm/INIT_FORM' = 'listo/orderForm/INIT_FORM';
export const INIT_CHECK_STOCK: 'listo/orderForm/INIT_CHECK_STOCK' = 'listo/orderForm/INIT_CHECK_STOCK';
export const RECEIVED_CHECK_STOCK: 'listo/orderForm/RECEIVED_CHECK_STOCK' = 'listo/orderForm/RECEIVED_CHECK_STOCK';
export const CHECK_STOCK_ERROR: 'listo/orderForm/CHECK_STOCK_ERROR' = 'listo/orderForm/CHECK_STOCK_ERROR';
export const OUT_OF_STOCK: 'listo/orderForm/OUT_OF_STOCK' = 'listo/orderForm/OUT_OF_STOCK';
export const ALTERNATIVES_OVERLAY_CLOSE: 'listo/orderForm/ALTERNATIVES_OVERLAY_CLOSE' = 'listo/orderForm/ALTERNATIVES_OVERLAY_CLOSE';
export const FORM_SUBMIT_START: 'listo/orderForm/FORM_SUBMIT_START' = 'listo/orderForm/FORM_SUBMIT_START';
export const FORM_SUBMIT_COMPLETE: 'listo/orderForm/FORM_SUBMIT_COMPLETE' = 'listo/orderForm/FORM_SUBMIT_COMPLETE';

export default null;
